<template>
  <div id="agency">
    <nav-common></nav-common>
    <div class="agency-content">
      <el-tabs v-model="manage" type="card" @tab-click="handleClick" v-loading="loading">
          <el-tab-pane label="管理代理" name="first">
              <el-form :inline="true" :model="search" class="demo-form-inline">
                  <el-form-item label="关键词">
                      <el-input v-model="search.word" placeholder="关键词"></el-input>
                  </el-form-item>
                  <el-form-item label="搜索条件">
                      <el-select v-model="search.field" placeholder="代理商账号">
                      <el-option label="代理商账号" value="loginName"></el-option>
                      <el-option label="代理商姓名" value="realname"></el-option>
                      </el-select>
                  </el-form-item>
                  <el-form-item>
                      <el-button type="primary" @click="getagency(1,search.field,search.word)">查询</el-button>
                  </el-form-item>
                  <el-form-item>当前代理总数：<span v-text="all_agent_count"></span></el-form-item>
              </el-form>
              <el-table
                  :data="agency.data"
                  border
                  style="width: 100%">
                  <el-table-column
                  fixed
                  prop="account"
                  label="代理商账号"
                  align="center"
                  width="150">
                  </el-table-column>
                  <el-table-column
                  prop="leading_official"
                  label="姓名"
                  align="center"
                  width="100">
                  </el-table-column>
                  <el-table-column
                  prop="pr"
                  label="所在省"
                  align="center"
                  width="100">
                  </el-table-column>
                  <el-table-column
                  prop="city"
                  label="所在市"
                  align="center"
                  width="100">
                  </el-table-column>
                  <el-table-column
                  prop="status"
                  label="状态"
                  align="center"
                  width="90">
                  </el-table-column>
                  <el-table-column
                  prop="card_count"
                  label="下级办卡"
                  align="center"
                  width="90">
                  </el-table-column>
                  <el-table-column
                  prop="sub_agent"
                  label="下下级办卡"
                  align="center"
                  width="100">
                  </el-table-column>
                  <el-table-column
                  prop="leader"
                  label="所属代理商"
                  align="center"
                  width="150">
                  </el-table-column>
                  <el-table-column
                  prop="remark"
                  label="备注"
                  align="center"
                  width="100">
                  </el-table-column>
                  <el-table-column
                  prop="created_at"
                  label="添加时间"
                  align="center"
                  width="205">
                  </el-table-column>
              </el-table>
              <el-pagination
                  background
                  layout="prev, pager, next"
                  @current-change="getagency"
                  :current-page="agency.current_page"
                  :total="agency.total">
              </el-pagination>
          </el-tab-pane>
          <!-- <el-tab-pane label="添加代理" name="add">
              <div class="add-box">
                  <el-form ref="addagency" :model="addagency" label-width="80px">
                      <el-form-item label="姓名">
                          <el-input v-model="addagency.leading_official"></el-input>
                      </el-form-item>
                      <el-form-item label="手机号码">
                          <el-input type="number" v-model="addagency.account"></el-input>
                      </el-form-item>
                      <el-form-item label="身份证号">
                          <el-input type="number" v-model="addagency.id_card"></el-input>
                      </el-form-item>
                      <el-form-item label="所在地">
                          <el-cascader
                              :options="addagency.options"
                              v-model="addagency.selectedOptions"
                              @change="selectArea">
                          </el-cascader>
                      </el-form-item>
                      <el-form-item label="详细地址">
                          <el-input v-model="addagency.address"></el-input>
                      </el-form-item>
                      <el-form-item label="备注">
                          <el-input type="textarea" v-model="addagency.remark"></el-input>
                      </el-form-item>
                      <el-form-item class="btn-box">
                          <el-button type="primary" @click="add()">添加代理</el-button>
                      </el-form-item>
                  </el-form>
              </div>
          </el-tab-pane> -->
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import NavCommon from '@/components/navtop/navcommon'

export default {
  name: 'Agency',
  data () {
    return {
        loading: false,
        addagency: {
            leading_official: '',
            account: '',
            id_card: '',
            area: '',
            address: '',
            remark: '',
            options: [],
            selectedOptions: []
        },
        manage: 'first',
        agency: [],
        all_agent_count: 0,
        search: {
          word: '',
          field: ''
        }
    }
  },
  created() {
      this.getagency();
      this.getArea()
  },
  methods: {
    handleClick(tab, event) {
        // console.log(tab, event);
    },
    getagency(page,field,keyword) {
        var _this = this;
        _this.$http({
            method: 'get',
            url: _this.$api + '/service/agent/agent_list?page=' + page + '&field=' + field + '&keyword=' + keyword
        }).then((res) => {
            var data =res.data.data;
            _this.agency = data;
            _this.all_agent_count = data.all_agent_count;
            _this.agency.data.forEach((item) => {
                item.leader = data.account;
                if(item.status == 0) {
                    item.status = '正常';
                } else {
                    item.status = '冻结';
                }
            })
        })
    },
    getArea() {
        var _this = this;
        this.$http({
            method: 'get',
            url: _this.$api + '/service/agent/all_area'
        }).then((res) => {
            this.addagency.options = res.data.data;
            this.addagency.options.forEach((element) => {
                element.children.forEach((item) => {
                    delete item.children;
                });
            });
        });
    },
    selectArea(value) {
        this.addagency.area = value[1];
    },
    add() {
        this.loading = true;
        var _this = this;
        var params = new URLSearchParams();
        var addagency = _this.addagency;
        params.append('account',addagency.account);
        params.append('leading_official',addagency.leading_official);
        params.append('area',addagency.area);
        params.append('address',addagency.address);
        params.append('id_card',addagency.id_card);
        params.append('remark',addagency.remark);
        params.append('status',0);
        _this.$http({
            method: 'post',
            url: _this.$api + '/service/agent/add',
            data: params
        }).then((res) => {
            _this.loading = false;
            if(res.data.code == 200) {
                _this.$message.success(res.data.data);
            } else {
                _this.$message.error(res.data.data)
            }
        })
    }
  },
  components: {
    NavCommon
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
    #agency
      .agency-content
        position relative
        margin 20px
        padding 60px 40px 20px 40px
        background #f8f8f8
        box-shadow 3px 3px 3px #f5f5f5 inset
        .el-tabs
          background #fff
          padding 15px
          .is-top
            background #f8f8f8
          .el-tabs__content
            padding 20px
            .el-table
              margin-bottom 15px
        .add-box
            width 400px
            margin-left 30px
        .btn-box
            text-align center
</style>



// WEBPACK FOOTER //
// src/components/agency/agency.vue